import { useCallback, useState } from 'react';
import { message } from 'antd';

type TEditingCard = { title: string; el?: HTMLElement | null };

// 记录 Practice setup / Profile 里哪些卡片正处于编辑态。
// 外层 Save / Send 只保存基础信息，卡片里的改动要靠卡片自己的 "Save changes"，
// 不拦的话点外层按钮会静默丢掉卡片里填的内容（2026-10-16 Thrive / Reagan Webb 事故）。
const useUnsavedCards = () => {
    const [editingCards, setEditingCards] = useState<TEditingCard[]>([]);

    const onEditingChange = useCallback((cardTitle: string, editing: boolean, cardEl?: HTMLElement | null) => {
        setEditingCards((prev) => {
            const rest = prev.filter((c) => c.title !== cardTitle);
            return editing ? [...rest, { title: cardTitle, el: cardEl }] : rest;
        });
    }, []);

    // 有未保存的卡片时：提示 + 滚到第一张未保存的卡片，返回 true，调用方据此中止
    const blockIfUnsaved = useCallback((): boolean => {
        if (!editingCards.length) return false;
        message.warning(
            `You have unsaved changes in ${editingCards
                .map((c) => c.title)
                .join(', ')}. Click "Save changes" in that section first, or Cancel to discard them.`,
        );
        editingCards[0].el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
    }, [editingCards]);

    // 切换 tab 会卸载当前 tab 的卡片，未保存的改动会被静默丢掉：有未保存时拦下并提示
    const runIfSaved = useCallback(
        (action: () => void) => {
            if (blockIfUnsaved()) return;
            action();
        },
        [blockIfUnsaved],
    );

    return { onEditingChange, blockIfUnsaved, runIfSaved };
};

export default useUnsavedCards;
